import {
    IDocumento,
    IDocumentoCreate,
} from "../../../Interfaces/Geral/CasoDocumentos/CasoDocumentosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarCasoDocumentoService(IDCaso: number) {
    return Service(
        Axios.get<Array<IDocumento>>(
            `/home/casodocumento/listarcasodocumento?IDCaso=${IDCaso}`
        )
    );
}

export async function GetDocumentoUAUService(requestBody: IDocumento) {
    return Service(
        Axios.post(`/home/casodocumento/getdocumentouau`, requestBody, {
            responseType: "blob",
        })
    );
}

export async function DeletarDocumentoService(ID_CASO_DOCUMENTO: number) {
    return Service(
        Axios.delete(
            `/home/casodocumento/deletedocumento?ID_CASO_DOCUMENTO=${ID_CASO_DOCUMENTO}`
        )
    );
}

export async function AtualizarDocumentoService(requestBody: IDocumento) {
    return Service(
        Axios.put(`/home/casodocumento/atualizardocumento`, requestBody)
    );
}

export async function ListarCasoDocumentoPorContaService(idConta: number) {
    return Service(
        Axios.get<Array<IDocumento>>(
            `/home/casodocumento/listacasodocumentoconta?idConta=${idConta}`
        )
    );
}

export async function ListarCasoDocumentoPorContaUAUService(idConta: number) {
    return Service(
        Axios.get<Array<IDocumento>>(
            `/home/casodocumento/listacasodocumentocontaUAU?idConta=${idConta}`
        )
    );
}

export async function InserirDocumentoDiretoEmCasoService(
    requestBody: IDocumentoCreate
) {
    return Service(
        Axios.post(`/home/casodocumento/inserircasodocumento`, requestBody)
    );
}
